<template>
    <div class="table_wrap mt10">
        <!--    <span class="total_length pb10">총 {{ paginationData.total }}개 </span>-->
        <el-table class="list-table" header-cell-class-name="list-header"
                  style="width: 100%;" height="895" empty-text="데이터가 없습니다."
                  :data="collectionData"
        >
            <el-table-column label="갤러리 명칭" width="" class-name="text-center" prop="c_title">
                <template slot-scope="scope">
                    <el-input class="snsInput mb10" type="text" v-model="scope.row.c_title"></el-input>
                </template>
            </el-table-column>
<!--            <el-table-column label="썸네일 이미지" width="150" class-name="text-center collection_img_box" prop="">
                <template slot-scope="scope">
                    <div class="collection_img thumbnail" @click="changeType(`collectionData[${scope.$index}]Files.Thumb`)">
                        <el-upload
                            action=""
                            class="avatar-uploader collection_thumb"
                            :auto-upload="false"
                            :show-file-list="false"
                            list-type="picture"
                            :on-change="onlyOneFileUpload"
                        >
                            <img v-if="hasFile(scope.row, 'Thumb')" :src="returnImage(scope.row)" class="avatar" alt="" >
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <button v-if="hasFile(scope.row, 'Thumb')" class="cancelBtn" @click.stop="deleteImg(scope.row, 'Thumb')"></button>
                        </el-upload>

                    </div>
                </template>
            </el-table-column>-->

            <el-table-column label="배경이미지" width="523" class-name="text-center collection_img_box" prop="">
                <template slot-scope="scope">
                    <div class="avatar-uploader collection_background" @click="changeType(`collectionData[${scope.$index}]Files.Background`)">
                        <el-upload
                            action=""
                            class="avatar-uploader"
                            :auto-upload="false"
                            :show-file-list="false"
                            list-type="picture"
                            :on-change="onlyOneFileUpload"
                        >
                            <img v-if="hasFile(scope.row, 'Background')" :src="returnBackImage(scope.row)" class="avatar" alt="" >
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
<!--                            <button v-if="hasFile(scope.row, 'Background')" class="cancelBtn" @click.stop="deleteImg(scope.row, 'Background')"></button>-->
                        </el-upload>

                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="옵션" width="200" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <!--            <el-button class="reg_btn_out" @click="saveFunc(scope.row.c_idx, 'collectionThumb', 'collectionBack')">-->
                        <el-button class="reg_btn_out" @click="saveFunc(scope.row)">
                            저장
                        </el-button>
                        <el-button class="com_del" @click="deleteFunc(scope.row, scope.row.c_idx)">
                            삭제
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import boardValidator from "@/mixins/validators/boardValidator";
import imageOption from "@/mixins/imageOption";
import elFileMixins from "@/mixins/elFileMixins";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";

export default {
    name: "CollectionListDefaultLayout",
    mixins:[boardValidator, imageOption, elFileMixins],
    components: {
    },
    inject: ['collectionListDelete', 'writeCollection', 'setCollectionListData'],
    provide() {
        return{

        }
    },
    props: {
        collectionData: {
            type: Array,
            default: () => {
                return []
            }
        },
        paginationData: {
            type: Object,
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },
    },
    data() {
        return{
            publicThumbnail: [],
            fileType: '',
        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {
        // this.setInitData();
    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
        parentChange(key, value) {
            this.setCollectionListData(key, value)
        },
        returnImg(typeName) {
            if (this.hasOwnProperty(typeName) && !util.isEmpty(this[typeName])) {
                if (this[typeName][0].org_name === 'no_file.png' || this[typeName][0].org_name === 'no_image.png') {
                    return false;
                }
                return true;
            }
        },
        returnImage(collection) {
            if(util.isEmpty(collection) || util.isEmpty(collection.Files) || util.isEmpty(collection.Files.Thumb)) {
                return "";
            }
            return util.isEmpty(collection.Files.Thumb[0].org_url) ? collection.Files.Thumb[0].url : `${collection.Files.Thumb[0].org_url}?${this.setImageOptions(378, 240, 'jpg')}`
        },
        returnBackImage(collection) {
            if(util.isEmpty(collection) || util.isEmpty(collection.Files) || util.isEmpty(collection.Files.Background)) {
                return "";
            }
            return util.isEmpty(collection.Files.Background[0].org_url) ? collection.Files.Background[0].url : `${collection.Files.Background[0].org_url}?${this.setImageOptions(378, 240, 'jpg')}`
        },
        hasFile(collection, type) {
            return !util.isEmpty(collection) && collection.hasOwnProperty("Files") && !util.isEmpty(collection.Files[type])
        },
        deleteImg(row, type){
            if (!this.hasFile(row, type)) {
                return '';
            }
            if(util.isEmpty(row.deleteFiles)){
                row.deleteFiles = [];
            }
            row.deleteFiles.push(row.Files[type][0]);
            row.Files[type] = [];
        },
        onlyOneFileUpload(file, fileList) {
            let maxSize = this.imageMaxSize;
            let type = file.raw.type.split('/');
            file.name = this.regExp(file.name)
            if (file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 ' + maxSize + '를 초과했습니다!');
                fileList.pop();
            } else if (!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            } else {
                let dataFile = this.$_.get(this, `${this.fileType}`) //this.a.b[1]
                if (this.fileType === '' || dataFile === undefined) {
                    if (this.files.length > 0 && this.files[0].hasOwnProperty('a_idx') && this.files[0].a_idx != null) {
                        file.a_idx = this.files[0].a_idx;
                    }
                    this.files[0] = file;
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange('files', this.files);
                    }
                } else {

                    let dataFile = this.$_.get(this, `${this.fileType}`)
                    if (dataFile.length > 0 && dataFile[0].hasOwnProperty('a_idx') && dataFile[0].a_idx != null) {
                        file.a_idx = dataFile[0].a_idx;
                    }
                    this.$_.set(this, `${this.fileType}`, []);
                    this.$_.set(this, `${this.fileType}[0]`, file);
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange(this.fileType, this[this.fileType]);
                    }
                }
            }
        },
        saveFunc(row) {
            if (!this.checkTitleValidator(row)) {
                this.errorAlert('제목을 입력해주세요.')
                return false;
            }
            if (!this.checkThumbValidator(row)) {
                this.errorAlert('썸네일 이미지를 등록해주세요.')
                return false;
            }
            if (!this.checkBackValidator(row)) {
                this.errorAlert('배경 이미지를 등록해주세요.')
                return false;
            }
            let params = this.makeParams(row)
            // let writeFunc = 'updateCollection'

            this.createConfirm({
                content: '저장하시겠습니까?',
                confirm: () => {
                    this.writeCollection(params)
                }
            })
        },
        checkTitleValidator(row){
            return !(util.isEmpty(row.c_title))
        },
        checkThumbValidator(row){
            return !(util.isEmpty(row.Files.Thumb))
        },
        checkBackValidator(row){
            return !(util.isEmpty(row.Files.Background))
        },
        makeParams(row) {
            let params = {}
            params.c_title = row.c_title
            params.thumbnail = row.Files.Thumb
            params.background = row.Files.Background
            params.deleteFiles = row.deleteFiles

            if (row.hasOwnProperty('c_idx') && !util.isEmpty(row.c_idx)) {
                params.c_idx = row.c_idx
            }
            return params
        },

        deleteFunc(row, idx) {
            let key = row.hasOwnProperty('c_idx') && !util.isEmpty(row.c_idx) ? row.c_idx : ''
            if (!util.isEmpty(key)) {
                this.collectionListDelete(key,idx)
            } else {
                this.collectionData.splice(idx, 1)
                this.filterData.splice(idx,1)
            }
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
